// extracted by mini-css-extract-plugin
module.exports = {"linkBox":"link-overlay_linkBox__Z41Uf","linkOverlay":"link-overlay_linkOverlay__fu69w"};